// src/hooks/useBarcodeScanner.js
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const useBarcodeScanner = () => {
  const navigate = useNavigate();
  const barcode = useRef('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = async (e) => {
      // بارکد ریدرها معمولاً به سرعت کلیدها را می‌فرستند و در نهایت Enter می‌زنند
      if (e.key === 'Enter') {
        e.preventDefault();

        let scannedCode = barcode.current.trim();

        // حذف فاصله‌ها + حذف TRIAL
        scannedCode = scannedCode
          .replace(/\s+/g, '')        // حذف همه فاصله‌ها
          .replace(/TRIAL/gi, '');    // حذف TRIAL (case-insensitive)

        if (scannedCode && scannedCode.length > 3) {
          try {
            const res = await axios.get(`/products/${scannedCode}`);
            const data = res.data;

            // اگر آرایه بود، اولین محصول رو بگیر (یا همه رو مدیریت کن)
            const product = Array.isArray(data) ? data[0] : data;

            if (product && product.barcode) {
              // هدایت به صفحه محصول با استفاده از barcode یا id
              navigate(`/product/${product.barcode || product.id}`);
            } else {
              alert('محصول با این بارکد یافت نشد');
            }
          } catch (err) {
            alert('خطا در ارتباط با سرور' +scannedCode);
          }
        }

        barcode.current = '';
      } else if (e.key.length === 1 && /[0-9a-zA-Z-]/.test(e.key)) {
        barcode.current += e.key;

        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          barcode.current = '';
        }, 300);
      }
    };

    // گوش دادن به تمام کلیدها در سطح document
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearTimeout(timeoutRef.current);
    };
  }, [navigate]);
};